var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "400.5px",
    height: "506.3px",
    viewBox: "0 0 400.5 506.3",
    enableBackground: "new 0 0 400.5 506.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    width: 1250,
    height: 506.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M6.687,9.978C-2.229-0.066-2.229,0,6.687,0c324.716,89.738,392.035,194.722,392.035,253.133 c0,58.412-91.385,164.119-392.035,253.134c-8.852,0.064-8.786-0.066,0-9.979c137.938-96.363,224.168-180.572,224.168-243.156 C230.855,188.688,155.22,111.779,6.687,9.978z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.88,94.897c-3.822-6.536-3.822-6.493,0-6.493c139.242,58.396,168.109,126.716,168.109,164.727 c0,38.011-39.187,106.8-168.109,164.726c-3.795,0.043-3.767-0.043,0-6.492c59.15-62.709,96.127-117.508,96.127-158.234 C115.007,211.193,82.573,161.144,18.88,94.897z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuIconWhite);
export default __webpack_public_path__ + "static/media/docu-icon-white.a3c9735b821e928cbfb361b92f531568.svg";
export { ForwardRef as ReactComponent };